'use client';

import { usePathname, useRouter } from 'next/navigation';
import { useLocale, useTranslations } from 'next-intl';
import { ArrowLeft } from 'lucide-react';
import { routing } from '@/i18n/routing';

/**
 * Global "previous page" control on every locale route (including landing).
 */
export default function GlobalHistoryBack() {
  const pathname = usePathname();
  const router = useRouter();
  const locale = useLocale();
  const t = useTranslations('CommonBreadcrumb');

  const isLanding = routing.locales.some(
    (loc) => pathname === `/${loc}` || pathname === `/${loc}/`
  );

  if (isLanding) return null;

  const hasOwnBack =
    /\/(dashboard|herramientas|especialistas|profesionales|legal)\b/.test(
      String(pathname || '')
    );
  if (hasOwnBack) return null;

  function goBack() {
    if (typeof window !== 'undefined' && window.history.length > 1) {
      router.back();
      return;
    }
    if (!isLanding) router.push(`/${locale}`);
  }

  return (
    <div className="fixed top-3 left-3 z-[100] sm:left-4">
      <button
        type="button"
        onClick={goBack}
        className="inline-flex items-center gap-1.5 rounded-lg border border-slate-700/80 bg-slate-950/80 px-2.5 py-1.5 text-xs font-semibold text-slate-300 backdrop-blur-md transition hover:border-cyan-500/50 hover:text-cyan-300"
        aria-label={t('ariaBack')}
        title={t('titleBack')}
      >
        <ArrowLeft className="h-3.5 w-3.5" />
        <span>{t('back')}</span>
      </button>
    </div>
  );
}
